const riskNO = {

    getDefault() {
        return {"pc":{"c0":5,"c1":6,"c2":8,"c3":9,"c4":9,"c00":3,"c01":4,"c02":5,"c00NO":1},"et":{"exas":4,"exasa":2,"exans":3,"exoff":3,"exfor":9,"exper":5,"exsti":4,"exsam":4,"exoth":8},"nc":{"nU":9,"nT":7,"nS":8,"nR":6,"nQ":4,"nP":4,"nO":2,"nN":5,"nM":5,"nL":7,"nK":7,"nJ":5,"nI":8,"nH":8,"nG":8,"nF":8,"nE":4,"nD":4,"nC":4,"nB":4,"nA":6},"sd":{"syo10":1,"syo5":3,"syo3":5,"syu3":6,"syu1":7,"smu6":8,"smu3":9},"kr":{"c0":4,"c1":6,"c2":8,"c3":9,"c4":9,"c00":3,"c00NO":1,"c01LU":6,"c01LI":6},"rh":{"hit00":5,"hit01":9}};
    },

};
export default riskNO;